"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _styledComponents = require("styled-components");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Option = require("./Option");

var _DropdownIndicator = require("./DropdownIndicator");

var _Control = require("./Control");

var _Placeholder = require("./Placeholder");

var _Menu = require("./Menu");

var _MenuList = require("./MenuList");

var _Group = require("./Group");

var _Input = require("./Input");

var _Dropdown = require("./Dropdown.style");

var _excluded = ["options", "components", "error"],
    _excluded2 = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Dropdown = function Dropdown(props) {
  var options = props.options,
      components = props.components,
      error = props.error,
      rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var ReactSelect = _reactSelect["default"];
  return /*#__PURE__*/_react["default"].createElement(ReactSelect, (0, _extends2["default"])({
    components: _objectSpread({
      Option: _Option.Option,
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      DropdownIndicator: _DropdownIndicator.DropdownIndicator,
      Control: _Control.Control,
      Placeholder: _Placeholder.Placeholder,
      Menu: _Menu.Menu,
      Group: _Group.Group,
      Input: _Input.Input,
      MenuList: _MenuList.MenuList
    }, components),
    options: options,
    menuPlacement: "bottom",
    styles: _Dropdown.styles,
    error: error,
    isOptionDisabled: function isOptionDisabled(option) {
      return option.isDisabled;
    }
  }, rest));
};

Dropdown.defaultProps = {
  size: 'medium',
  error: false
};
Dropdown.propTypes = {
  options: _propTypes["default"].array,
  placeholder: _propTypes["default"].string,
  components: _propTypes["default"].node,
  onChange: _propTypes["default"].func,
  label: _propTypes["default"].string,
  error: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool,
  menuIsOpen: _propTypes["default"].bool,
  size: _propTypes["default"].oneOf(['small', 'medium'])
};

Dropdown.HelperText = function (_ref) {
  var children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_Dropdown.HelperText, props, children);
};

Dropdown.HelperText.propTypes = {
  children: _propTypes["default"].node
};

var _default = (0, _styledComponents.withTheme)(Dropdown);

exports["default"] = _default;